/**
 * This function checks if element is visible in viewport
 * @param {nodeElement} element
 * @param {number=1} enoughHeightRatio consider element as visible if this part of its height is seen in viewport
 */
export const isElementVisibleInViewport = (element, enoughHeightRatio = 1) => {
  if (!element?.nodeType) {
    return false;
  }

  const bounding = element.getBoundingClientRect();
  const stickyHeaderHeight = document.querySelector('.mn_pageHeader.mn_sticky')?.offsetHeight || 0;

  return (
    bounding.bottom >= bounding.height * enoughHeightRatio + stickyHeaderHeight &&
    bounding.top <= (window.innerHeight || document.documentElement.clientHeight) - bounding.height * enoughHeightRatio
  );
};
